import MessageFormat from 'messageformat';
import Dictionary from './dictionary';

/**
 * Translator class that expects a dictionary of this format:
 *
 * {
 *  key: {
 *     'en_us': <value>,
 *     'de_de': <value>
 *  },
 *  key1: {
 *     'en_us': <value>,
 *     'de_de': <value>
 *  }
 * }
 */

/**
 * Translates the given key or returns the default text.
 *
 * @param {*} key
 * @param {*} defaultText
 * @param {*} locale
 */
export function translate(key) {
  var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en_us';
  if (!key) {
    return defaultText;
  }
  var keyObj = Dictionary.getTranslations()[key];
  if (!keyObj) {
    return defaultText;
  } else {
    var value = keyObj[locale];
    if (!value) {
      return defaultText;
    }
    return value;
  }
}
var mf = new MessageFormat('en');
var messageMap = new Map();

/**
 * Formats the text using an object. See messageformat.github.io
 *
 * @param {*} value
 * @param {*} options
 */
export function format(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = messageMap.get(value);
  if (!message) {
    message = compile(value);
  }
  return message(options);
}

/**
 * Compile the message. Separate function because V8 deopts funcs with try-catch and
 * this gets called a lot.
 *
 * @param {string} message
 */
function compile(message) {
  try {
    return mf.compile(message);
  } catch (e) {
    console.error('Error compiling message. Returning function that renders the raw message.', e);
    return function () {
      return message;
    };
  }
}
//# sourceMappingURL=translate.js.map
